import updateImageOnImageSet from "./updateImageOnImageSet";

export const appearancePageImageSetEvent = "nexthink.appearance-page.event.image.set.1";
export const appearancePageImageResetEvent = "nexthink.appearance-page.event.image.reset.1";

export const subscriptions = {
  [appearancePageImageSetEvent]: [updateImageOnImageSet],
  [appearancePageImageResetEvent]: [updateImageOnImageSet],
};
